/* bristm-quote — word-by-word reveal of the quote (loaded only where the section renders) */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function split(el) {
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    var i = 0;
    nodes.forEach(function (node) {
      var parts = node.nodeValue.split(/(\s+)/);
      var frag = document.createDocumentFragment();
      parts.forEach(function (part) {
        if (!part) return;
        if (/^\s+$/.test(part)) {
          frag.appendChild(document.createTextNode(part));
          return;
        }
        var span = document.createElement('span');
        span.className = 'b-quote__w';
        span.style.setProperty('--i', i++);
        span.textContent = part;
        frag.appendChild(span);
      });
      node.parentNode.replaceChild(frag, node);
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-b-quote-text]').forEach(function (el) {
      if (el.dataset.bQuoteBound) return;
      el.dataset.bQuoteBound = '1';
      if (reduce || !('IntersectionObserver' in window)) return;
      split(el);
      el.classList.add('is-split');
      var io = new IntersectionObserver(
        function (entries) {
          if (entries[0].isIntersecting) {
            el.classList.add('is-in');
            io.disconnect();
          }
        },
        { rootMargin: '0px 0px -12% 0px', threshold: 0.1 }
      );
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
